/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Button, Form, Input, message, Modal } from "antd";
import React, { useCallback } from "react";
import { useFormatMessage } from "src/hooks";
import messageIds from "src/locales/messageIds";
import { UserSeviceClient } from "src/services/UserManagementService";

export default React.memo(
  (props: {
    isShow: boolean;
    onShowClose: () => void;
    userId: string;
    list: () => void;
  }) => {
    const { isShow, onShowClose, userId, list } = props;
    const formatMessage = useFormatMessage();
    const [form] = Form.useForm();

    const onUpdate = useCallback(async () => {
      const password = await form.validateFields();
      UserSeviceClient.updatePassword(userId, password).then(() => {
        message.success(formatMessage(messageIds.common.updateSuccessfully));
        list();
        onShowClose();
        form.resetFields();
      });
    }, [form, formatMessage, list, onShowClose, userId]);

    const onClose = useCallback(() => {
      onShowClose();
      form.resetFields();
    }, [form, onShowClose]);

    return (
      <div>
        <Modal
          title={formatMessage(messageIds.userManagement.updatePassword)}
          visible={isShow}
          onCancel={onClose}
          footer={""}
          css={css`
            .ant-modal-header {
              border-bottom: none;
            }
          `}
        >
          <Form form={form} layout="vertical">
            <Form.Item
              label={formatMessage(messageIds.userManagement.password)}
              name="password"
              rules={[{ required: true }]}
            >
              <Input.Password
                placeholder={formatMessage(messageIds.common.pleaseInput)}
                autoComplete="off"
              ></Input.Password>
            </Form.Item>
          </Form>
          <div
            css={css`
              text-align: right;
              margin-top: 20px;
            `}
          >
            <Button
              type="primary"
              css={css`
                height: 32px;
                min-width: 88px;
                border-radius: 4px;
              `}
              onClick={onUpdate}
            >
              {formatMessage(messageIds.common.confirm)}
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
);
